// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"9c15260b","596":"ed84fac6","679":"9e23b8a6","923":"31d6cfe0"}[chunkId] + ".chunk.css";
};